export function getOSInfo() {
  const userAgent = navigator.userAgent;

  if (/windows nt/i.test(userAgent)) return 'Windows';
  if (/macintosh|mac os x/i.test(userAgent)) return 'macOS';
  if (/linux/i.test(userAgent)) return 'Linux';
  if (/android/i.test(userAgent)) return 'Android';
  if (/iphone|ipad|ipod/i.test(userAgent)) return 'iOS';

  return 'UnknownOS';
}

export function getBrowserInfo(): string {
  // Chromium-based browsers expose structured UA data
  const userAgentData = (
    navigator as Navigator & {
      userAgentData?: { brands?: Array<{ brand: string; version: string }> };
    }
  ).userAgentData;

  if (userAgentData?.brands?.length) {
    const primaryBrowser = userAgentData.brands.find(
      (brandData) => brandData.brand !== 'Not:A-Brand',
    );
    return primaryBrowser?.brand ?? 'UnknownBrowser';
  }

  // Fallback for Safari/Firefox/older browsers
  const ua = navigator.userAgent;

  if (ua.includes('Edg/')) return 'Edge';
  if (ua.includes('OPR/') || ua.includes('Opera')) return 'Opera';
  if (ua.includes('Chrome/')) return 'Chrome';
  if (ua.includes('Safari/') && !ua.includes('Chrome/')) return 'Safari';
  if (ua.includes('Firefox/')) return 'Firefox';
  if (ua.includes('SamsungBrowser')) return 'Samsung Internet';
  if (ua.includes('YaBrowser')) return 'Yandex';
  if (ua.includes('UCBrowser')) return 'UC Browser';
  if (ua.includes('QQBrowser')) return 'QQ Browser';
  if (ua.includes('Maxthon')) return 'Maxthon';
  if (ua.includes('Weibo')) return 'Weibo';
  if (ua.includes('Liebao')) return 'Liebao';

  return 'UnknownBrowser';
}
